import { useEffect, useState } from 'react';

import { api } from 'services/api';

import { ProductType } from '../models/product';

export function useProductTypes(): ProductType[] {
  const [productTypes, setProductTypes] = useState<ProductType[]>([]);

  useEffect(() => {
    api
      .get<{ data: ProductType[] }>('/admin/filter-options/product-classes')
      .then(({ data }) => {
        setProductTypes(data.filter(item => !!item.class));
      })
      .catch(err => Promise.reject(err.message));
  }, []);

  return productTypes;
}
